export type PrefabModelType = (typeof PrefabModelType)[keyof typeof PrefabModelType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PrefabModelType = {
    Representation: 'Representation',
    SubPart: 'SubPart',
    Group: 'Group'
} as const;
